import { Stub } from '@direct-frontend/components';
import styles from './Step.module.css';

export const StepStub = () => <Stub borderRadius="14" className={styles.step} height={48} />;
